import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DateTimezoneService } from '@services/date-timezone.service';

@Pipe({ name: 'customDateTimeByUtc' })
export class CustomDateTimeByUtcPipe implements PipeTransform {
  constructor(private datePipe: DatePipe, private dateTimezoneService: DateTimezoneService) {}

  public transform(value: any): string | null {
    if (!value) {
      return '';
    }

    return this.datePipe.transform(
      this.dateTimezoneService.formatViewValueWithRemovalOfZones(value, 'MM/dd/yyyy', '+0000'),
      'MM/dd/yyyy HH:mm',
      '+0000',
    );
  }
}
